/* ============================================
   АНИМИРОВАННЫЙ КОД НА ФОНЕ - НАЧАЛО
   
   Чтобы отключить:
   1. Закомментируйте импорт CodeRain в App.js
   2. Удалите <CodeRain /> из App.js
   
   ============================================ */

/**
 * Компонент с эффектом печатающихся строк кода на фоне
 */

import { useEffect, useState, useRef } from 'react';
import './CodeRain.css';

const codeLines = [
    // Короткие строки (быстро печатаются)
    { text: 'let x = 0', speed: 20 },
    { text: 'count++', speed: 15 },
    { text: 'return true', speed: 18 },
    { text: 'break', speed: 12 },
    { text: 'continue', speed: 15 },
    
    // Средние строки
    { text: 'const App = () => { return <div>Hello</div> }', speed: 25 },
    { text: 'function getData() { return fetch("/api") }', speed: 28 },
    { text: 'if (user.isAuth) { console.log("OK") }', speed: 30 },
    { text: 'const styles = { color: "#B8FF65" }', speed: 25 },
    { text: 'const [state, setState] = useState(0)', speed: 27 },
    { text: 'useEffect(() => { document.title = "App" })', speed: 30 },
    { text: 'import React from "react"', speed: 22 },
    { text: 'export const Button = ({ children }) => {}', speed: 28 },
    { text: 'const isValid = data.length > 0', speed: 25 },
    { text: 'interface User { id: number; name: string }', speed: 26 },
    { text: 'type Props = { title: string }', speed: 24 },
    { text: 'async function fetchUser(id) {}', speed: 27 },
    { text: 'const config = { apiUrl: "/api" }', speed: 25 },
    { text: 'const routes = ["/", "/about", "/services"]', speed: 28 },
    { text: 'for (let i = 0; i < 10; i++) { sum += i }', speed: 30 },
    { text: 'const theme = { primary: "#B8FF65" }', speed: 26 },
    { text: 'return <Layout><Content /></Layout>', speed: 28 },
    { text: 'const handleClick = (e) => e.preventDefault()', speed: 30 },
    { text: 'import { useState, useEffect } from "react"', speed: 27 },
    { text: 'export default function Page() { return null }', speed: 32 },
    { text: 'const items = data.filter(x => x.active)', speed: 28 },
    { text: 'if (error) { throw new Error("Failed") }', speed: 30 },
    { text: 'const API_URL = process.env.REACT_APP_API', speed: 29 },
    { text: 'document.querySelector(".btn").click()', speed: 27 },
    { text: 'localStorage.setItem("token", response.data)', speed: 31 },
    { text: 'const navigate = useNavigate()', speed: 25 },
    { text: 'router.push("/dashboard")', speed: 23 },
    { text: 'const isLoading = status === "pending"', speed: 28 },
    { text: 'return response.json()', speed: 22 },
    { text: 'const filtered = arr.filter(x => x > 10)', speed: 29 },
    { text: 'setTimeout(() => { callback() }, 1000)', speed: 30 },
    { text: 'const sorted = [...items].sort((a, b) => a - b)', speed: 32 },
    { text: 'const merged = { ...defaults, ...options }', speed: 30 },
    { text: 'export { default as App } from "./App"', speed: 28 },
    { text: 'import type { User } from "./types"', speed: 26 },
    { text: 'const memo = useMemo(() => expensive(), [deps])', speed: 32 },
    { text: 'useCallback(() => { doSomething() }, [])', speed: 30 },
    { text: 'const ref = useRef(null)', speed: 24 },
    { text: 'const context = useContext(AppContext)', speed: 28 },
    { text: 'const [loading, setLoading] = useState(false)', speed: 31 },
    { text: 'if (condition) { return early }', speed: 26 },
    { text: 'switch (type) { case "A": return 1 }', speed: 29 },
    { text: 'const sum = numbers.reduce((a, b) => a + b, 0)', speed: 32 },
    { text: 'const hasItem = array.includes(value)', speed: 28 },
    { text: 'const index = data.findIndex(x => x.id === id)', speed: 31 },
    { text: 'const sliced = arr.slice(0, 10)', speed: 26 },
    { text: 'arr.push(item); arr.pop()', speed: 24 },
    { text: 'const joined = parts.join(", ")', speed: 26 },
    { text: 'const split = str.split(" ")', speed: 25 },
    { text: 'const lower = text.toLowerCase()', speed: 27 },
    { text: 'const replaced = str.replace(/old/g, "new")', speed: 30 },
    { text: 'const parsed = JSON.parse(jsonString)', speed: 28 },
    { text: 'const stringified = JSON.stringify(obj)', speed: 29 },
    { text: 'Math.random() * 100', speed: 20 },
    { text: 'Math.floor(value)', speed: 18 },
    { text: 'Date.now()', speed: 15 },
    { text: 'new Date().toISOString()', speed: 23 },
    { text: 'console.log("Debug:", value)', speed: 26 },
    { text: 'console.error("Error:", err)', speed: 26 },
    { text: 'throw new Error("Invalid input")', speed: 28 },
    { text: 'await delay(1000)', speed: 20 },
    { text: 'Promise.resolve(value)', speed: 22 },
    { text: 'typeof value === "string"', speed: 24 },
    { text: 'value instanceof Array', speed: 22 },
    { text: 'Array.isArray(value)', speed: 21 },
    { text: 'Number.isNaN(num)', speed: 19 },
    { text: 'Object.freeze(obj)', speed: 20 },
    { text: 'delete obj.property', speed: 21 },
    
    // Длинные строки (медленнее печатаются)
    { text: 'data.map(item => <Card key={item.id} title={item.title} onClick={() => handleClick(item)} />)', speed: 35 },
    { text: 'try { await api.post("/data", body) } catch (e) { console.error(e) }', speed: 38 },
    { text: 'class Component extends React.Component { componentDidMount() {} }', speed: 40 },
    { text: 'const handleSubmit = async (data) => { const result = await save(data); return result }', speed: 42 },
    { text: 'const result = await Promise.all(promises.map(p => p.then(r => r.data)))', speed: 40 },
    { text: 'Object.keys(obj).forEach(key => console.log(key, obj[key]))', speed: 38 },
    { text: 'window.addEventListener("scroll", handleScroll, { passive: true })', speed: 39 },
    { text: 'axios.get("/api/users").then(res => res.data).catch(err => console.error(err))', speed: 42 },
    { text: 'const user = await db.users.findOne({ id }).populate("profile")', speed: 38 },
    { text: 'const reducer = (state, action) => { switch(action.type) { default: return state } }', speed: 43 },
    { text: 'const match = text.match(/[a-zA-Z0-9]+/g) || []', speed: 36 },
    { text: 'const promise = new Promise((resolve, reject) => setTimeout(resolve, 1000))', speed: 41 },
    
    // Комментарии
    { text: '// TODO: Implement user authentication', speed: 22 },
    { text: '// FIXME: Handle edge case for empty array', speed: 24 },
    { text: '// Initialize app state', speed: 18 },
    { text: '// Fetch data from API', speed: 17 },
    { text: '// Clean up resources', speed: 16 },
    { text: '// Update component on prop change', speed: 20 },
];

function CodeRain() {
    const [lines, setLines] = useState([]);
    const [enabled, setEnabled] = useState(() => {
        if (typeof window === "undefined") return false;
        return window.matchMedia("(min-width: 861px)").matches
            && !window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    });

    useEffect(() => {
        const widthMq = window.matchMedia("(min-width: 861px)");
        const reduceMq = window.matchMedia("(prefers-reduced-motion: reduce)");
        const sync = () => setEnabled(widthMq.matches && !reduceMq.matches);
        widthMq.addEventListener("change", sync);
        reduceMq.addEventListener("change", sync);
        sync();
        return () => {
            widthMq.removeEventListener("change", sync);
            reduceMq.removeEventListener("change", sync);
        };
    }, []);

    useEffect(() => {
        if (!enabled) {
            setLines([]);
            return undefined;
        }

        let scrollingFast = false;
        let lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
        let lastScrollT = performance.now();
        let scrollIdleTimer = 0;

        const shouldPause = () => document.hidden || scrollingFast;

        const onScroll = () => {
            const now = performance.now();
            const y = window.pageYOffset || document.documentElement.scrollTop;
            const dt = Math.max(now - lastScrollT, 1);
            const dy = Math.abs(y - lastScrollY);
            lastScrollY = y;
            lastScrollT = now;
            if (dy > 48 || dy / dt > 1.5) {
                scrollingFast = true;
            }
            window.clearTimeout(scrollIdleTimer);
            scrollIdleTimer = window.setTimeout(() => {
                scrollingFast = false;
            }, 160);
        };

        window.addEventListener("scroll", onScroll, { passive: true });

        const cleanupInterval = setInterval(() => {
            if (shouldPause()) return;
            // Очистка невидимых строк каждые 2 секунды
            setLines(prev => {
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const windowHeight = window.innerHeight;
                const visibleTop = scrollTop;
                const visibleBottom = scrollTop + windowHeight;
                
                // Оставляем только строки в видимой области (с запасом ±200px)
                return prev.filter(line => {
                    const lineTop = line.y * 30;
                    return lineTop >= visibleTop - 200 && lineTop <= visibleBottom + 200;
                });
            });
        }, 2000);

        const checkDistance = (x, y, existingLines) => {
            // Проверяем минимальное расстояние 10% по X и 7% по Y
            const minDistanceX = 10;
            const minDistanceY = 7;
            
            for (let line of existingLines) {
                const distanceX = Math.abs(line.x - x);
                const distanceY = Math.abs(line.y - y);
                
                if (distanceX < minDistanceX && distanceY < minDistanceY) {
                    return false; // Слишком близко
                }
            }
            return true; // Достаточно далеко
        };

        const addNewLine = () => {
            if (shouldPause()) return;

            let x, y;
            let attempts = 0;
            const maxAttempts = 30;
            
            setLines(prev => {
                // ОГРАНИЧЕНИЕ: максимум 12 строк одновременно
                if (prev.length >= 12) {
                    return prev;
                }
                
                // Получаем текущую позицию скролла
                const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                const windowHeight = window.innerHeight;
                
                // Пытаемся найти свободную позицию в видимой области
                do {
                    x = Math.random() * 90; // 0-90% от ширины
                    // Генерируем Y в пикселях относительно текущей видимой области
                    const relativeY = Math.random() * windowHeight;
                    y = (scrollTop + relativeY) / 30; // Конвертируем обратно в наш формат
                    attempts++;
                } while (!checkDistance(x, y, prev) && attempts < maxAttempts);
                
                // Если не нашли свободную позицию - все равно добавляем (для непрерывности)
                if (attempts >= maxAttempts) {
                    x = Math.random() * 90;
                    const relativeY = Math.random() * windowHeight;
                    y = (scrollTop + relativeY) / 30;
                }
                
                const codeLine = codeLines[Math.floor(Math.random() * codeLines.length)];
                const newLine = {
                    id: Date.now() + Math.random(),
                    text: codeLine.text,
                    speed: codeLine.speed,
                    x,
                    y,
                };
                
                // Удаляем строку через 5 секунд (быстрее для ротации)
                setTimeout(() => {
                    if (shouldPause()) return;
                    setLines(current => current.filter(line => line.id !== newLine.id));
                }, 5000);
                
                return [...prev, newLine];
            });
        };

        // ЦИКЛИЧНАЯ АНИМАЦИЯ - бесконечный цикл
        // Добавляем новую строку каждые 0.6-1.2 секунды
        const interval = setInterval(() => {
            addNewLine();
        }, Math.random() * 600 + 600);

        // Добавляем первые 10 строк постепенно (максимум 12)
        for (let i = 0; i < 10; i++) {
            setTimeout(addNewLine, i * 700 + Math.random() * 400);
        }

        // Гарантируем оптимальное количество строк на экране (6-12)
        const ensureOptimalLines = setInterval(() => {
            if (shouldPause()) return;
            setLines(prev => {
                if (prev.length < 6) {
                    // Если строк меньше 6, добавляем еще
                    addNewLine();
                }
                return prev;
            });
        }, 2000);

        return () => {
            window.removeEventListener("scroll", onScroll);
            window.clearTimeout(scrollIdleTimer);
            clearInterval(interval);
            clearInterval(cleanupInterval);
            clearInterval(ensureOptimalLines);
        };
    }, [enabled]);

    if (!enabled) {
        return null;
    }

    return (
        <div className="code-rain">
            {lines.map(line => (
                <CodeLine
                    key={line.id}
                    text={line.text}
                    speed={line.speed}
                    x={line.x}
                    y={line.y}
                />
            ))}
        </div>
    );
}

// Прямой DOM — ноль React ре-рендеров во время печати
function CodeLine({ text, speed, x, y }) {
    const spanRef = useRef(null);
    const cursorRef = useRef(null);

    useEffect(() => {
        const span = spanRef.current;
        const cursor = cursorRef.current;
        if (!span) return;

        let idx = 0;
        let tid;

        const step = () => {
            idx++;
            span.textContent = text.slice(0, idx);
            if (idx < text.length) {
                tid = setTimeout(step, speed);
            } else {
                if (cursor) cursor.style.display = 'none';
            }
        };

        tid = setTimeout(step, speed);
        return () => clearTimeout(tid);
    }, [text, speed]);

    return (
        <div
            className="code-rain__line"
            style={{ left: `${x}%`, top: `${y * 30}px` }}
        >
            <span ref={spanRef} />
            <span ref={cursorRef} className="code-rain__cursor" />
        </div>
    );
}

export default CodeRain;

/* АНИМИРОВАННЫЙ КОД НА ФОНЕ - КОНЕЦ */
/* ============================================ */
